/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusLegalComplianceDto } from '../../models/lexplus-legal-compliance-dto';

export interface AuswertungenControllerGetLegalComplianceV1$Params {

/**
 * Start of the range, inclusive. Without it the range has no start.
 */
  dateFrom?: string;

/**
 * End of the range; the whole day it names is included. Without it the range has no end.
 */
  dateTo?: string;

/**
 * The Standorte the history is read for. Without them every Standort the user may see.
 */
  standortIDs?: Array<number>;
}

export function auswertungenControllerGetLegalComplianceV1(http: HttpClient, rootUrl: string, params?: AuswertungenControllerGetLegalComplianceV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusLegalComplianceDto>>> {
  const rb = new RequestBuilder(rootUrl, auswertungenControllerGetLegalComplianceV1.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('standortIDs', params.standortIDs, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusLegalComplianceDto>>;
    })
  );
}

auswertungenControllerGetLegalComplianceV1.PATH = '/v1/auswertungen/legal-compliance';
